import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { ShopErrorFragment } from "@saleor/fragments/types/ShopErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getShopErrorMessage from "@saleor/utils/errors/shop";
import React from "react";
import { useIntl } from "react-intl";

import { SiteSettingsPageFormData } from "../SiteSettingsPage";

interface SiteSettingsDetailsProps {
  data: SiteSettingsPageFormData;
  errors: ShopErrorFragment[];
  disabled: boolean;
  onChange: (event: React.ChangeEvent<any>) => void;
}

const SiteSettingsDetails: React.FC<SiteSettingsDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(
    ["name", "domain", "title", "description", "keywords", "shopApiUri"],
    errors
  );

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          error={!!formErrors.name}
          fullWidth
          name="name"
          label={intl.formatMessage({
            defaultMessage: "Name of your store"
          })}
          helperText={
            getShopErrorMessage(formErrors.name, intl) ||
            intl.formatMessage({
              defaultMessage:
                "Name of your store is shown on tab in web browser"
            })
          }
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.domain}
          fullWidth
          name="domain"
          label={intl.formatMessage({
            defaultMessage: "URL of your online store"
          })}
          helperText={getShopErrorMessage(formErrors.domain, intl)}
          value={data.domain}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.title}
          fullWidth
          name="title"
          label={intl.formatMessage({
            defaultMessage: "Seo title"
          })}
          helperText={
            getShopErrorMessage(formErrors.title, intl) ||
            intl.formatMessage({
              defaultMessage: "Seo title is shown on website"
            })
          }
          value={data.title}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.description}
          fullWidth
          name="description"
          label={intl.formatMessage({
            defaultMessage: "Seo Description"
          })}
          helperText={
            getShopErrorMessage(formErrors.description, intl) ||
            intl.formatMessage({
              defaultMessage: "Seo description is shown on website"
            })
          }
          value={data.description}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.keywords}
          fullWidth
          name="keywords"
          label={intl.formatMessage({
            defaultMessage: "Seo keywords"
          })}
          helperText={
            getShopErrorMessage(formErrors.keywords, intl) ||
            intl.formatMessage({
              defaultMessage: "Seo keywords is shown on website"
            })
          }
          value={data.keywords}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.shopApiUri}
          fullWidth
          name="shopApiUri"
          label={intl.formatMessage({
            defaultMessage: "shopApiUri"
          })}
          helperText={
            getShopErrorMessage(formErrors.shopApiUri, intl) ||
            intl.formatMessage({
              defaultMessage: "shop Api Uri shown on dashboard"
            })
          }
          value={data.shopApiUri}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          fullWidth
          name="shopViewPageManageUri"
          label={intl.formatMessage({
            defaultMessage: "shopViewPageManageUri"
          })}
          helperText={
            intl.formatMessage({
              defaultMessage: "shop view page manage uri"
            })
          }
          value={data.shopViewPageManageUri}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};
SiteSettingsDetails.displayName = "SiteSettingsDetails";
export default SiteSettingsDetails;
